import React from 'react';
import { func } from 'prop-types';
import {
  ButtonGroup, DrawerBody, DrawerFooter
} from '@one-thd/sui-atomic-components';
import { useStoreId } from '@thd-nucleus/experience-context';
import { ProductQuickView } from '@thd-olt-component-react/product-info-quick-view';
import { useMessage } from '../../../hooks/useMessage';
import { usePromoDrawerModel } from '../../../hooks/usePromoDrawerModel';
import { useProduct } from '../../../hooks/useProduct';
import { MESSAGE_KEY, PRODUCT_CTA_TYPE } from '../../../utils/constants';
import { AddToCartCta } from '../../AddToCartCta/AddToCartCta';
import { SeeFullDetailsButton } from '../../SeeFullDetailsButton/SeeFullDetailsButton';
import { PromoSelectCta } from '../../PromoSelectCta/PromoSelectCta';
import { PromoDrawerHeader } from './subcomponents/PromoDrawerHeader';
import { usePromoModel } from '../../../hooks/usePromoModel';

export const QuickviewDrawer = ({ onBack, onClose }) => {
  const storeId = useStoreId();
  const { quickviewItemDisplayPosition, quickviewItemId } = usePromoDrawerModel();
  const { type, anchorItemId, isBogoPair } = usePromoModel();
  const {
    isSoldOut,
    productCtaType,
    selected,
    selectProduct
  } = useProduct(quickviewItemId, quickviewItemDisplayPosition);
  const templateTitle = useMessage(MESSAGE_KEY.title);
  const pairTitle = useMessage(MESSAGE_KEY.pairTitle);
  const title = isBogoPair ? pairTitle : templateTitle;

  const isBogoCardAnchorSku = type !== 'card' && quickviewItemId !== anchorItemId;
  const showAddToCartCta = isBogoCardAnchorSku && productCtaType === PRODUCT_CTA_TYPE.addToCart;
  const showPromoSelectButton = isBogoCardAnchorSku && productCtaType === PRODUCT_CTA_TYPE.select;

  return (
    <>
      <PromoDrawerHeader onBack={onBack} onClose={onClose} title={title} />
      <DrawerBody>
        <ProductQuickView itemId={quickviewItemId} storeId={storeId} showReview />
      </DrawerBody>
      <DrawerFooter data-testid="quickview-drawer-footer">
        <ButtonGroup>
          <SeeFullDetailsButton fullWidth itemId={quickviewItemId} />
          {showPromoSelectButton ? (
            <PromoSelectCta
              isSoldOut={isSoldOut}
              itemId={quickviewItemId}
              onSelect={selectProduct}
              selected={selected}
            />
          ) : <div hidden />}
          {showAddToCartCta ? (
            <AddToCartCta
              align="center"
              displayPosition={quickviewItemDisplayPosition}
              itemId={quickviewItemId}
            />
          ) : <div hidden />}
        </ButtonGroup>
      </DrawerFooter>
    </>
  );
};

QuickviewDrawer.displayName = 'QuickviewDrawer';

QuickviewDrawer.propTypes = {
  onBack: func.isRequired,
  onClose: func.isRequired
};

QuickviewDrawer.dataModel = ProductQuickView.dataModel;
